<template>
  <div class="body">
    <div class="main_container">
      <!-- <training-header></training-header> -->
      <!-- page content -->
      <div class="right_col" role="main" style="margin-left: 0;background-color: #fff;">
        <br />
        <div class="row px-4 pt-3 pb-5">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="x_panel qestion_page">
              <div class="x_content">
                <div class="dashboard-widget-content">
                  <div class="row">
                    <div class="col-md-9">
                      <div class="c_num">
                        <!-- <img
                            id="certificate"
                            src="../assets/img/unfillcertificate.jpg"
                            style="display: block;margin: 0 auto;width: 800px;margin-bottom: 4%;"
                        /> -->
                        <!-- <p id="certificate_exam_id">
                          Certificate No. :
                          <span id="certificate_no">AD45678XR5678906</span>
                        </p> -->
                        <canvas id="myCanvas" width="800" height="297" style="border:1px solid #d3d3d3;"></canvas>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <div class="row">
                        <div class="col-12">
                          <div
                          class="button-div"
                          style="padding-top: 3%; padding-bottom: 3%; margin-top: 50%;"
                          >
                          <button class="btn btn-primary" @click="downloadCertificate" style="margin-right: 2%; color: #fff;">Download Certificate</button>


                            <!-- <a href="#" class="btn" id="download" role="button" @click="downloadCertificate(this)" style="margin-right: 2%; background-color: #15797c; color: #fff;"
                            >Download Certificate</a> -->
                          </div>
                        </div>
                        <div class="col-12" style="display:flex; justify-content:center;">
                          <a v-if="route == 'score-board'" class="btn btn-headerbutton text-white" href="#/score-board" style="background-color: #1d5288; border-color: #1d5288; padding: 6px 70px; margin-top: 4%;">Back</a>
                          <a v-else class="btn btn-headerbutton text-white" href="#/certificate-status" style="background-color: #1d5288; border-color: #1d5288; padding: 6px 70px; margin-top: 4%;">Back</a>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /page content -->

      <!-- footer content -->
      <!-- <training-footer></training-footer> -->
      <!-- /footer content -->
    </div>
  </div>
</template>

<script>
import trainingHeader from "../components/trainingHeader";
import trainingFooter from "../components/trainingFooter";
import image from "../assets/img/cerficateupdated.png"
export default {
  components: {
    trainingHeader,
    trainingFooter
  },
  data(){
    return {
      from: '',
      route: localStorage.getItem("route-name")
    }
  },
  methods:{
      createCertificate(){
        let routeName = localStorage.getItem("route-name")
        let examDetails = null
        if(routeName == 'score-board'){
          examDetails = JSON.parse(localStorage.getItem("score-board"))
        }else{
          examDetails = JSON.parse(localStorage.getItem("certificate-data"))
        }

        var canvas = document.getElementById("myCanvas"),
        ctx = canvas.getContext("2d");
        canvas.width = 900;
        canvas.height = 471;
        var background = new Image();
        background.src = image;

        background.onload = function(){
            ctx.drawImage(background,0,0);
            ctx.fillStyle = "#5a6268";
            ctx.font = "bold 20px Roboto";
            ctx.fillText(examDetails.userName.toUpperCase(), 350, 250);
            //ctx.fillText('Mr. Lorem Ipsum'.toUpperCase(), 350, 250);
            ctx.fillText(examDetails.score, 480, 310);
            ctx.fillText(examDetails.result.toUpperCase(), 450, 365);
            //ctx.font = "20px Roboto";
            ctx.fillText('Certificate No. :'+examDetails.examId, 485, 430);
        }
      },
      downloadCertificate(el){
        var canvas = document.getElementById("myCanvas");
        var image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
        var link = document.createElement('a');
        link.download = "certificate.png";
        link.href = image;
        link.click();
      }
  },
  mounted(){
    this.createCertificate()
  }
}
</script>
<style scoped>
    .x_panel {
        background-color: #fff;
        border: 0px solid transparent;
        padding:0;
        border-radius: 7px;
    }
    .x_title {
        border-bottom: 0px solid #E6E9ED;
        padding: 15px 18px;
        background-color: #b0b0b0;
        color: #fff;
        border-radius: 7px 7px 0 0;
    }
    .x_content {
        padding: 0 25px 6px;
    }
    .button-div{
        display: flex;
        justify-content: center;
        margin-bottom: 4%;
    }
</style>
